var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4999 8.5L18.9999 1",
    stroke: "#E13F29",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1H19V6",
    stroke: "#E13F29",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 11.9999V16.9999C18.9999 17.5304 18.7892 18.0391 18.4142 18.4142C18.0391 18.7892 17.5304 18.9999 16.9999 18.9999H2.99994C2.46951 18.9999 1.9608 18.7892 1.58573 18.4142C1.21065 18.0391 0.999939 17.5304 0.999939 16.9999V2.99994C0.999939 2.46951 1.21065 1.9608 1.58573 1.58573C1.9608 1.21065 2.46951 0.999939 2.99994 0.999939H7.99994",
    stroke: "#E13F29",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.6e6339ac35e19225cbbaebab38f99e68.svg";
export { ForwardRef as ReactComponent };